import React from 'react';
import isBefore from 'date-fns/is_before';
import { Formik } from 'formik';
import { stringify } from 'query-string';
import { decamelizeKeys } from 'humps';
import { FormGroup, Label, InputGroup, Button } from 'reactstrap';

import TransportationLocation from './TransportationLocation';
import TransportationDateRangePicker from './TransportationDateRangePicker';
import injectTransportationSearchParams from './injectTransportationSearchParams';
import { CustomCounter, CustomRadioGroup } from '../../../components';

import createInitialValues from './createInitialValues';
import { TRIP_TYPE_OPTIONS } from './constants';

TransportationSearchFormGroup.defaultProps = {
  onSuccess: () => { },
};

function TransportationSearchFormGroup(props) {
  const { onSuccess, history, queryParams } = props;

  function onSubmit(values) { 
    const formData = { ...values };

    const isOneWay = formData.tripType === 'O';
    if (isOneWay) delete formData.arrivalDate;
    formData.tripType2 = formData.tripType;

    onSuccess();

    history.push({
      pathname: '/transportation/list',
      search: `?${stringify(decamelizeKeys(formData))}`,
    });
  }

  return (
    <Formik initialValues={createInitialValues(queryParams)}
      validate={validateForm}
      onSubmit={onSubmit}>
      {({ handleSubmit }) => {
        return (
          <React.Fragment>
            <div className="radio-wrap">
              <Label className="sr-only">Trip</Label>
              <FormGroup>
                <CustomRadioGroup name="tripType" options={TRIP_TYPE_OPTIONS} />
              </FormGroup>
            </div>
            <div className="field-wrapper">
              <TransportationLocation title="From" name="fromLocation" />
              <TransportationLocation title="To" name="toLocation" />
              <TransportationDateRangePicker />
              <CustomCounter title="Passenger"/>
              <FormGroup>
              <Label className="title invisible mb-0">Action</Label>
                <InputGroup>
                  <Button color="yellow" onClick={handleSubmit} id="transportation-search-button">
                    SEARCH
                  </Button>
                </InputGroup>
              </FormGroup>
            </div>
          </React.Fragment>
        );
      }}
    </Formik>
  );
}

export default injectTransportationSearchParams(TransportationSearchFormGroup);

function validateForm(values) {
  const { arrivalDate, departureDate, tripType } = values;
  const isRoundTrip = tripType === 'R';

  let errors = {};

  if (isRoundTrip) {
    if (!arrivalDate) errors.arrivalDate = 'Please enter your arrival date';
    if (isBefore(arrivalDate, departureDate)) errors.arrivalDate = 'Arrival date cannot be before than departure date';
  }
  
  if (!departureDate) errors.departureDate = 'Please enter your departure date';

  return errors;
}



// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/TransportationSearchForm.js